import React, { useEffect, useState, useRef, useCallback} from 'react';
import {
    AiOutlinePlusCircle,
    AiOutlineDelete,
    AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { FaTimes } from 'react-icons/fa';
import { useLocation} from 'react-router-dom';

const getLocalTodayDate = () => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
};

const maskPhone = (phone) => {
    if (!phone) return "";
    return String(phone).slice(0, 5) + "*****";
};

const getStaffFollowUpContext = (empId, name, branchId) => ({
    owner: { value: empId || '', label: [empId, name].filter(Boolean).join(' - ') },
    branch: { value: branchId || '', label: String(branchId || '') },
    date: getLocalTodayDate()
});

const FollowUp = ({ adminData, companyID, branchID,financialYear }) => {
 const location = useLocation();


     const searchInputRef = useRef(null);
    const loggedEmpId = adminData?.user?.emp_id;
    const loggedEmpName =
        `${adminData?.user?.first} ${adminData?.user?.last}`;
    const isStaff = localStorage.getItem('role') === 'employee';
    const staffName = [adminData?.user?.first, adminData?.user?.middle, adminData?.user?.last]
        .map(part => (part || '').trim()).filter(Boolean).join(' ');
    const staffContextRef = useRef(null);
    staffContextRef.current = isStaff ? getStaffFollowUpContext(loggedEmpId, staffName, branchID) : null;
    const staffOwner = staffContextRef.current?.owner;



    // ========================useStates=========================
    const { setLoading } = useLoading();
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success',
    });
    
useEffect(() => {
  if (location.state && location.state.showForm) {
    setShowForm(true);
    const partyData = location.state.partyData;
    if (partyData) {
      const initialPhones = [
        partyData.mobile,
        partyData.phone,
        partyData.number
      ].filter(Boolean);
      const initialMasked = initialPhones.map(ph => maskPhone(ph)).join(", ") || (partyData.maskedContacts || "");

      setFormData(previous => ({
        ...previous,
        partyId: partyData.partyId || "",
        party: partyData.party || "",
        site: partyData.site || "",
        maskedContacts: initialMasked,
        state: partyData.state || "",
        city: partyData.city || "",
        region: partyData.region || "",
        pincode: partyData.pincode || "",
        ...(staffContextRef.current || {})
      }));

      if (partyData.partyId) {
        axios.get(`https://api.skyguard.group/api/fetch-partyId/${partyData.partyId}`)
          .then(res => {
            if (res.data) {
              const p = res.data;
              const phoneList = [
                p.phone,
                p.mobile,
                p.phone_two,
                p.phone_three,
                p.contact_no
              ].filter(Boolean);
              const masked = phoneList.map(ph => maskPhone(ph)).join(", ") || maskPhone(p.mobile || p.phone);

              setFormData(prev => ({
                ...prev,
                partyId: p.id,
                party: p.name || prev.party,
                site: p.address || prev.site,
                maskedContacts: masked || prev.maskedContacts,
                state: p.state || prev.state,
                city: p.city || prev.city,
                region: p.region || prev.region,
                pincode: p.pin || prev.pincode,
              }));
            }
          })
          .catch(err => {
            console.error("Error fetching party details in FollowUp:", err);
          });
      }
    }
  }
}, [location.state]);
  

    const [showForm, setShowForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [FollowUpList, setFollowUpList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [partyOptions, setPartyOptions] = useState([]);
    const [showPartyModal, setShowPartyModal] = useState(false);
    const [showOptionModal, setShowOptionModal] = useState(false);
    const [search, setSearch] = useState("");
    const [branchDetail, setBranchDetail] = useState([])
    const staffBranch = {
        value: branchID || '',
        label: String(branchDetail.id) === String(branchID) ?
            [branchDetail.name, branchDetail.city].filter(Boolean).join(' - ') : String(branchID || '')
    };

    const [statusOptions, setStatusOptions] = useState([]);

    const [historyLogs, setHistoryLogs] = useState([]);

    const navigate = useNavigate();


    const getTodayDate = () => {
        if (isStaff) return getLocalTodayDate();
        return new Date().toISOString().split("T")[0];
    };

    const getTodayDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    };

      const [offset, setOffset] = useState(0);
                      const limit = 20;
                      const [hasMore, setHasMore] = useState(true);
                      const [fromDate, setFromDate] = useState();
                      const [toDate, setToDate] = useState();
                      const [isLocked, setIsLocked] = useState(false);
                      const [fy, setFy] = useState([]);
                  
                      const [financialRange, setFinancialRange] = useState({
                          from_date: '',
                          to_date: ''
                      });


    const [formData, setFormData] = useState({
        followup_id: null,
        owner: isStaff ? staffOwner : "",
        partyId: "",
        party: "",
        maskedContacts: "",
        site:'',
        status: "",
        branch: isStaff ? staffBranch : "",
        date: getTodayDate(),
        refDoc: "",
        remark: "",
        tableRows: [
            { type: "", date: getTodayDateTime(), remark: "", nextDate: "", status: '', }
        ]
    });

    const hasPartyForFollowUp = Boolean(showForm && !formData.followup_id && formData.partyId);
    const partyHistoryRef = useRef({ partyId: null, request: 0 });
    partyHistoryRef.current.partyId = hasPartyForFollowUp ? formData.partyId : null;

    const fetchPartyHistory = useCallback(async (partyId) => {
        const request = ++partyHistoryRef.current.request;
        try {
            const res = await axios.get('https://api.skyguard.group/api/followups', {
                params: { party_id: partyId, history: 1 }
            });
            if (request === partyHistoryRef.current.request &&
                String(partyHistoryRef.current.partyId) === String(partyId)) {
                setHistoryLogs(res.data.filter(item => String(item.party_id) === String(partyId))
                    .flatMap(item => item.logs || [])
                    .sort((a, b) => Number(b.id) - Number(a.id)));
            }
        } catch (err) {
            if (request === partyHistoryRef.current.request &&
                String(partyHistoryRef.current.partyId) === String(partyId)) {
                setHistoryLogs([]);
                console.error('Error fetching party follow-up history:', err);
            }
        }
    }, []);

    useEffect(() => {
        if (!hasPartyForFollowUp) return;
        const history = partyHistoryRef.current;
        setHistoryLogs([]);
        fetchPartyHistory(formData.partyId);
        return () => { history.request += 1; };
    }, [hasPartyForFollowUp, formData.partyId, fetchPartyHistory]);

      useEffect(() => {
                      if (showPartyModal) {
                        setTimeout(() => {
                          searchInputRef.current?.focus();
                        }, 100);
                      }
                    }, [showPartyModal]);

    // ========================handlers==========================
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };

    const handleAddClick = () => {
        if (isStaff) {
            setFormData(previous => ({
                ...previous,
                owner: staffOwner,
                branch: staffBranch,
                date: getTodayDate()
            }));
        }
        setShowForm(true);
    };

    const filteredData = FollowUpList.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (isStaff && ['owner', 'branch', 'date'].includes(name)) return;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSelectChange = (selected, name) => {
        if (isStaff && ['owner', 'branch', 'date'].includes(name)) return;
        setFormData(prev => ({
            ...prev,
            [name]: selected
        }));
    };

    const handleTableChange = (index, field, value) => {
        const updated = [...formData.tableRows];
        updated[index][field] = value;

        setFormData(prev => ({
            ...prev,
            tableRows: updated
        }));
    };

    const filtered = partyOptions.filter(
        (p) =>
            p.label.toLowerCase().includes(search.toLowerCase()) ||
            p.phoneList.some((ph) =>
                ph.toLowerCase().includes(search.toLowerCase())
            ) ||
            (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
    );

    const limitText = (text, limit) => {
        if (!text) return "";
        return text.length > limit ? text.slice(0, limit) + "..." : text;
    };

    const reset = () => {
        partyHistoryRef.current.request += 1;
        setHistoryLogs([]);
        setShowForm(false);
        setFormData({
            followup_id: null,
            owner: isStaff ? staffOwner : "",
            partyId: "",
            party: "",
            maskedContacts: "",
            site: "",
            pincode: "",
            state: "",
            city: "",
            region: "",
            status: "",
            branch: isStaff ? staffBranch : "",
            date: getTodayDate(),
            remark: "",
            tableRows: [
                { type: "", date: getTodayDateTime(), remark: "", nextDate: "", status: '' }
            ]
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const owner = isStaff ? loggedEmpId : formData.owner?.value;
        const branch = isStaff ? branchID : formData.branch?.value;
        if (isStaff && (!owner || !branch)) {
            showToast('Current employee and login branch are required', 'danger');
            return;
        }

        try {
            //  EDIT MODE
            if (formData.followup_id) {

                // 1Update followup master
                await axios.put(
                    `https://api.skyguard.group/api/followups/${formData.followup_id}`,
                    {
                        owner,
                        branch,
                        status: formData.status?.value,
                        date: formData.date,
                        remark: formData.remark,

                        last_updated_by_emp_id: loggedEmpId,
                        last_updated_by_name: loggedEmpName
                    }
                );

                // 2Insert NEXT followup log
                await axios.post(
                    `https://api.skyguard.group/api/followups/${formData.followup_id}/log`,
                    {
                        owner,
                        tableRows: formData.tableRows
                    }
                );

                // alert("");
                showToast('FollowUp updated successfully!', 'success');
            }

            //  CREATE MODE
            else {
                await axios.post("https://api.skyguard.group/api/followups", {
                    owner,
                    party_id: formData.partyId,
                    branch,
                    status: formData.status?.value,
                    date: formData.date,
                    remark: formData.remark,
                    tableRows: formData.tableRows,
                    // audit fields
                    created_by_emp_id: loggedEmpId,
                    created_by_name: loggedEmpName,
                });

                // alert("FollowUp created successfully");
                showToast('FollowUp created successfully!', 'success');
            }

            if (location.state?.showForm && formData.partyId) {
                setFormData(previous => ({
                    ...previous,
                    remark: "",
                    tableRows: [
                        { type: "", date: getTodayDateTime(), remark: "", nextDate: "", status: '' }
                    ]
                }));
                await fetchPartyHistory(formData.partyId);
            } else {
                reset();
            }
            setOffset(0);
            await fetchFollowUps(
                financialRange.from_date,
                financialRange.to_date,
                branchDetail.code,
                0
            );

        } catch (err) {
            console.error(err);
            // alert("Error saving follow-up");
            showToast('Error saving follow-up!', 'danger');
        }
    };





    const handleEdit = (data) => {

        const maskedPhones = data.phones
            ?.map(ph => maskPhone(ph))
            .join(", ");
        setFormData({
            followup_id: data.followup_id,
            owner: isStaff ? staffOwner : employeeList.find(e => e.value === data.owner_emp_id),
            partyId: data.party_id,
            party: data.party_name,
            maskedContacts: maskedPhones,
            status: statusOptions.find(s => s.label === data.status_name),
            branch: isStaff ? staffBranch : branchList.find(b => b.label.includes(data.branch_name)),
            date: data.followup_date,
            remark: data.remark,


            tableRows: [
                {
                    type: "",
                    date: getTodayDateTime(),
                    remark: "",
                    nextDate: "",
                    status: '',
                }
            ]
        });

        //  SET HISTORY
        setHistoryLogs(data.logs || []);

        setShowForm(true);
    };



    // =========================apis=============================
    const fetchEmployeeData = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const data = res.data.result;
            console.log(data);

            const formatted = data.filter(emp => !emp.seperation_date)
             .filter(emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== "")
            .map(emp => {
                const first = (emp.first || '').trim();
                const middle = (emp.middle || '').trim();
                const last = (emp.last || '').trim();

                const fullName = [first, middle, last].filter(Boolean).join(' ');

                return {
                    id: emp.id,
                    value: emp.emp_id,
                    label: `${emp.emp_id} - ${fullName}`,
                    empName: fullName,
                };
            });

            setEmployeeList(formatted);
        } catch (err) {
            console.error('Error fetching employee data:', err);
        }
    };

    //============= branch=======
    const fecthDetail = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-branch');
            const data = res.data.result;

            const formatted = data.map(branch => ({
                value: branch.id,
                label: `${branch.name} - ${branch.city}`,
                ...branch
            }));

            setBranchList(formatted);

        } catch (error) {
            console.log("Error fetching branch:", error);
        }
    };

    // ==========party============
    const fetchPartyDetail = async () => {
        try {
            const resParty = await axios.get("https://api.skyguard.group/api/fetch-party");
            // console.log(resParty);

            const options = resParty.data.map((p) => ({
                party_id: p.id,
                label: p.name,
                phoneList: [
                    p.phone,
                    p.mobile,
                    p.phone_two,
                    p.phone_three,
                    p.contact_no
                ].filter(Boolean),
                address: p.address || "",
                pin: p.pin || "",
                state: p.state || "",
                city: p.city || "",
                region: p.region || "",
            }));


            setPartyOptions(options);
        } catch (error) {
            console.log(error);
        }
    };

    // ==========FOLLOWUPSTATUS=======
    const fetchStatusList = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-followup-status');
            // console.log(res);
            const options = res.data.map(item => ({
                value: item.id,
                label: item.status
            }));
            setStatusOptions(options);

        } catch (err) {
            console.error(err);
        }
    };


    
    const fetchFollowUps = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {

        if (isStaff && !branchID) {
            setFollowUpList([]);
            return;
        }

        setLoading(true);
        try {
            const params = {
                limit: limit,
                offset: newOffset
            };

            if (fromDate && toDate) {
                params.from_date = fromDate;
                params.to_date = toDate;
            }

            if (isStaff && branchID) {
                params.branch_id = branchID;
            } else if (branchID) {
                params.branch_id = branchID;
            }

            if (branchCode) {
                params.branch_code = branchCode;
            }

            const res = await axios.get('https://api.skyguard.group/api/followups', { params });

            const sortedData = res.data.sort((a, b) => {
                const getLatestDate = (item) => {
                    if (!item.logs || item.logs.length === 0) return 0;

                    return Math.max(
                        ...item.logs.map(log => new Date(log.next_followup_datetime).getTime())
                    );
                };

                return getLatestDate(b) - getLatestDate(a);
            });

            const result = sortedData;
            if (newOffset === 0) {
                setFollowUpList(result);
                setHasMore(true);
            } else {
                setFollowUpList(prev => {
                    const merged = [...prev, ...result];
                    const unique = Array.from(
                        new Map(merged.map(item => [item.followup_id || item.id, item])).values()
                    );
                    return unique;
                });
            }

            if (result.length < limit) {
                setHasMore(false);
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchBranchDetail = async () => {
        if (!branchID) return null;
        setLoading(true);
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data);
            return branchRes.data.code;
        } catch (error) {
            console.log("Error fetching branch detail:", error);
            return null;
        } finally {
            setLoading(false);
        }
    };

    const fetchYearDetail = async () => {
        if (isStaff && !branchID) {
            setFollowUpList([]);
            return;
        }
        setLoading(true);
        let branchCode = null;
        try {
            if (branchID) {
                branchCode = await fetchBranchDetail();
            }
            if (!financialYear) {
                await fetchFollowUps('', '', branchCode);
                return;
            }
            const res = await axios.get(
                `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
            );
            const yearData = res.data;
            if (!yearData || !yearData.from_date) {
                await fetchFollowUps('', '', branchCode);
                return;
            }
            setFy(yearData);
            setIsLocked(yearData.is_locked === 1);
            setFinancialRange({
                from_date: yearData.from_date,
                to_date: yearData.to_date
            });

            await fetchFollowUps(
                yearData.from_date,
                yearData.to_date,
                branchCode,
            );
        } catch (error) {
            console.log("Error fetching financial year details:", error);
            await fetchFollowUps('', '', branchCode);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!isStaff) {
            fetchEmployeeData();
            fecthDetail();
        }
        fetchPartyDetail();
        fetchStatusList();

        fetchYearDetail();
    }, [isStaff, branchID, financialYear]);

    const getStatusLabel = (statusId) => {
        if (!statusId || !statusOptions.length) return "";

        return (
            statusOptions.find(opt => opt.value === Number(statusId))?.label || ""
        );
    };


     const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

    fetchFollowUps(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>FollowUp </h3>
                    {/* Search and Add */}
                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleAddClick}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>
                    {/* Form Section */}
                    {showForm && (
                        <div className="card p-3 my-3 shadow-sm bg-white border">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    {/* left side */}
                                    <div className="col-md-6">

                                        {formData.followup_id && (
                                             <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`FLW/${formData.followup_id}/${branchDetail.code}`}
    </span>
  </div>

 
)}
                                        <div className="row g-3">
                                            {/*Owner*/}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Owner</label>
                                                <Select
                                                    options={isStaff ? [staffOwner] : employeeList}
                                                    value={isStaff ? staffOwner : formData.owner}
                                                    isDisabled={isStaff}
                                                    onChange={(selected) => handleSelectChange(selected, "owner")}
                                                    required
                                                />
                                            </div>
                                            {/*Select Party*/}
                                            <div className="col-12">
                                                <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Choose Party..."
                                                    value={formData.party}
                                                    readOnly
                                                    onClick={() => setShowPartyModal(true)}
                                                    required
                                                />
                                            </div>
                                            {/*Status*/}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Status</label>
                                                <Select
                                                    options={statusOptions}
                                                    value={formData.status}
                                                    onChange={(selected) => handleSelectChange(selected, "status")}
                                                    placeholder="Select Status"
                                                    required
                                                />

                                            </div>
                                        </div>
                                    </div>
                                    {/* right-side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* branch, date */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label className="form-label fw-medium">Select branch</label>
                                                        <Select
                                                            options={isStaff ? [staffBranch] : branchList}
                                                            value={isStaff ? staffBranch : formData.branch}
                                                            isDisabled={isStaff}
                                                            onChange={(selected) => handleSelectChange(selected, "branch")}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='date' className="form-label fw-medium"> Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="date"
                                                            id='date'
                                                            readOnly={isStaff}
                                                            value={formData.date}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Contact No.   */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className="col-md-6">
                                                        <label htmlFor='contact' className="form-label fw-medium"> Contact No.</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={formData.maskedContacts}
                                                            readOnly
                                                            placeholder="Auto-filled after party selection"
                                                        />
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <label className="form-label fw-medium">Ref. Doc</label>
                                                        <Select
                                                        />
                                                    </div>


                                                </div>

                                            </div>
                                            <div className="col-12">
                                                <div className='row g-2'>

                                                    <div className="col-md-6" style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <label className="form-label fw-medium">Register New Call</label>
                                                        <button type="button" className="btn btn-info"
                                                            onClick={() =>
                                                                navigate("/admin/crm/complaint", {
                                                                    state: {
                                                                        showAddForm: true,
                                                                        partyData: {
                                                                            partyid: formData.partyId,
                                                                            party: formData.party,
                                                                            site: formData.site,
                                                                            contact_no: formData.maskedContacts
                                                                        }
                                                                    }
                                                                })
                                                            }
                                                        >
                                                            Click Here
                                                        </button>
                                                    </div>





                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-12 mt-3'>
                                        <label htmlFor='remark' className="form-label fw-medium">Remarks</label>
                                        <textarea
                                            className="form-control"
                                            name="remark"
                                            id='remark'
                                            placeholder="Enter here..."
                                            rows="6"
                                            value={formData.remark}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="table-responsive my-4">
                                        <table className="table table-bordered mx-auto text-center align-middle w-100">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{ minWidth: "130px", width: "15%" }}>Type</th>
                                                    <th style={{ minWidth: "170px", width: "20%" }}>Date</th>
                                                    <th style={{ minWidth: "220px", width: "30%" }}>Remark</th>
                                                    <th style={{ minWidth: "170px", width: "20%" }}>Next Date</th>
                                                    <th style={{ minWidth: "180px", width: "15%" }}>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData?.tableRows?.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>
                                                            <select name='type'
                                                                required
                                                                className='form-select'
                                                                value={item.type}
                                                                onChange={(e) =>
                                                                    handleTableChange(idx, "type", e.target.value)
                                                                }
                                                            >
                                                                <option value=""> ---Select--- </option>
                                                                <option value="Phone">Phone</option>
                                                                <option value="Email">Email </option>
                                                                <option value="Visit">Visit</option>
                                                                <option value="Fax">Fax</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="datetime-local"
                                                                className="form-control"
                                                                value={item.date}
                                                                onChange={(e) =>
                                                                    handleTableChange(idx, "date", e.target.value)
                                                                }
                                                                disabled
                                                            />
                                                        </td>
                                                        <td>
                                                            <textarea
                                                                className="form-control"
                                                                rows="3"
                                                                value={item.remark}
                                                                onChange={(e) =>
                                                                    handleTableChange(idx, "remark", e.target.value)
                                                                }
                                                            ></textarea>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="datetime-local"
                                                                className="form-control"
                                                                value={item.nextDate}
                                                                onChange={(e) =>
                                                                    handleTableChange(idx, "nextDate", e.target.value)
                                                                }
                                                            />
                                                        </td>
                                                        <td style={{ minWidth: "180px", textAlign: "left" }}>
                                                            <Select
                                                                options={statusOptions}
                                                                value={
                                                                    statusOptions.find(opt => opt.label === item.status) ||
                                                                    (item.status ? { value: item.status, label: item.status } : null)
                                                                }
                                                                onChange={(selected) => handleTableChange(idx, "status", selected?.label)}
                                                                placeholder="Select Status"
                                                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                                menuPosition="fixed"
                                                                styles={{
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                    control: base => ({
                                                                        ...base,
                                                                        textAlign: 'left',
                                                                        minHeight: '38px',
                                                                        borderRadius: '0.375rem',
                                                                        borderColor: '#dee2e6'
                                                                    }),
                                                                    menu: base => ({
                                                                        ...base,
                                                                        textAlign: 'left',
                                                                        zIndex: 9999
                                                                    }),
                                                                    singleValue: base => ({
                                                                        ...base,
                                                                        textAlign: 'left'
                                                                    }),
                                                                    placeholder: base => ({
                                                                        ...base,
                                                                        textAlign: 'left'
                                                                    })
                                                                }}
                                                            />
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <h3 className="fw-bold text-danger-emphasis border-start border-4 border-primary ps-3 my-3">FollowUp Overview</h3>

                                    {/* table */}
                                    <div className="table-responsive my-4">
                                        <table className="table table-striped-columns text-center align-middle w-75 mx-auto table-sm ">
                                            <thead className="table-dark">
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                    <th>Remarks</th>
                                                    <th>NextDate</th>
                                                    <th>Employee</th>
                                                    <th>Status</th>
                                                    <th>Saved</th>
                                                    <th>Play</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historyLogs.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="7">No follow-up history</td>
                                                    </tr>
                                                ) : (
                                                    historyLogs.map((log, idx) => (

                                                        <tr key={idx}>

                                                            <td>{log.type}</td>
                                                            <td>{log.contact_datetime}</td>
                                                            <td>{log.remark}</td>
                                                            <td>{log.next_followup_datetime}</td>
                                                            <td>{log.employee_id}</td>
                                                            <td>{log.status}</td>
                                                            <td>✔</td>
                                                            <td>
                                                                <button className="btn btn-sm btn-secondary">
                                                                    ▶
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>

                                        </table>

                                    </div>
                                </div>
                                {/* save/Cancel */}
                                <div className='d-flex justify-content-center mt-4 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        SAVE
                                    </button>
                                    <button type='button' className='btn btn-danger'
                                        onClick={reset}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                      <th>Action</th>
                                    <th>Doc No</th>
                                    <th>NextDate</th>

                                    <th>Party</th>

                                    <th>Region</th>
                                    <th>Status</th>

                                    <th>Created By</th>
                                    <th>Created At</th>
                                    <th>Last Updated By</th>
                                    <th>Last Updated At</th>
                                  
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((item, index) => (
                                    <tr key={item.followup_id}>
                                           <td>
                                            <button
                                                className="btn btn-sm btn-warning"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <AiOutlineEdit size={18} />
                                            </button>
                                        </td>
                                        <td>{`FLW/${item.followup_id}/${branchDetail?.code || item.branch_name || ''}/${new Date().getFullYear()}`}</td>
                                        <td>
                                            {item.logs[0]?.next_followup_datetime || "---"}
                                        </td>

                                        <td>{item.party_name}</td>
                                        <td>{item.branch_name}</td>
                                        <td>{item.status_name}</td>
                                        <td>
                                            {item.created_by_name} ({item.created_by_emp_id})
                                        </td>

                                        <td>
                                            {new Date(item.created_at).toLocaleString()}
                                        </td>

                                        <td>
                                            {item.last_updated_by_name
                                                ? `${item.last_updated_by_name} (${item.last_updated_by_emp_id})`
                                                : "---"}
                                        </td>

                                        <td>
                                            {item.last_updated_at
                                                ? new Date(item.last_updated_at).toLocaleString()
                                                : "---"}
                                        </td>
                                     
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                            {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>


            {/* Inline Modal */}
            <Modal
                show={showPartyModal}
                onHide={() => setShowPartyModal(false)}
                size="lg"
                centered
                dialogClassName="party-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">🔍 Search Party</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {/* Search Bar */}
                    <div className="mb-3">
                        <Form.Control
                            type="text"
                            className="search-box"
                            placeholder="Search party by name, phone, or address..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                                 ref={searchInputRef}
                        />
                    </div>

                    {/* Responsive Table */}
                    <div className="table-responsive table-wrapper shadow-sm rounded">
                        <Table hover className="party-table">
                            <thead>
                                <tr>
                                      <th className="text-center">Action</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                  
                                </tr>
                            </thead>

                            <tbody>
                                {filtered.map((p) => (
                                    <tr key={p.value} className="row-hover">

                                         {/* SELECT BUTTON */}
                                        <td className="text-center">
                                            <Button
                                                className="select-btn"
                                                onClick={() => {
                                                    const maskedPhones = p.phoneList
                                                        .map(ph => maskPhone(ph))
                                                        .join(", ");

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        partyId: p.party_id,
                                                        party: p.label,
                                                        maskedContacts: maskedPhones,
                                                        site: p.address || "",
                                                        pincode: p.pin || "",
                                                        state: p.state || "",
                                                        city: p.city || "",
                                                        region: p.region || "",
                                                    }));

                                                    setShowPartyModal(false);
                                                }}
                                            >
                                                Select
                                            </Button>

                                        </td>
                                        <td>{p.label}</td>

                                        {/* PHONE  */}
                                        <td
                                            className="truncate"
                                            title={p.phoneList.join(", ")}
                                        >
                                            {limitText(p.phoneList.join(", "), 20)}
                                        </td>

                                        {/* ADDRESS  */}
                                        <td
                                            className="truncate"
                                            title={p.address}
                                        >
                                            {limitText(p.address, 30)}
                                        </td>


                                       
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
        </>
    )
}

export default FollowUp
